import ConfigProvider from 'antd/es/config-provider';
import React from 'react';

import { ButtonHtmlType } from '@/enums';

import * as Style from './OutlinedButton.style';

interface Props {
  children: React.ReactNode;
  htmlType?: ButtonHtmlType;
  loading?: boolean;
  disabled?: boolean;
  height?: string;
  width?: string;
  fontSize?: string;
  onClick?: () => void;
  className?: string;
  gradient?: string;
  style?: React.CSSProperties;
}

const OutlinedButton = ({
  children,
  htmlType = ButtonHtmlType.Button,
  ...rest
}: Props) => {
  return (
    <ConfigProvider
      theme={{
        cssVar: true,
        hashed: false,
        token: {
          colorSplit: '#f2f2f2',
        },
        components: {
          Button: {
            defaultBg: 'transparent',
            defaultBorderColor: '#f2f2f2',
            defaultColor: '#f2f2f2',
            defaultHoverColor: '#0d2926',
            defaultHoverBg: '#f2f2f2',
            defaultHoverBorderColor: '#f2f2f2',
            defaultActiveBg: '#f2f2f2',
            defaultActiveBorderColor: '#f2f2f2',
            defaultActiveColor: '#0d2926',
          },
        },
      }}
    >
      <Style.OutlinedButton
        variant="outlined"
        shape="round"
        autoInsertSpace={false}
        htmlType={htmlType}
        {...rest}
      >
        <Style.OutlinedButtonText
          ellipsis={{ rows: 1 }}
          className="button-text"
        >
          {children}
        </Style.OutlinedButtonText>
      </Style.OutlinedButton>
    </ConfigProvider>
  );
};

export default OutlinedButton;
